import { SideNavCategory } from '../../../components/side-nav';
import { ReportField } from '../../../models/reportField';
import combineMyFieldsWithSearchableCategories from './combineMyFieldsWithSearchableCategories';

const buildSideNavCategories = (
  favoriteFields: SideNavCategory<ReportField>[],
  recentFields: SideNavCategory<ReportField>[],
  standardFields: SideNavCategory<ReportField>[],
): SideNavCategory<ReportField>[] => {
  const myFieldsItem = {
    key: 'MyFields',
    name: 'My Fields',
    items: [],
  };
  myFieldsItem.items.push({
    key: 'Recents',
    name: 'Recents',
    items: recentFields,
  });
  myFieldsItem.items.push({
    key: 'Favorites',
    name: 'Favorites',
    items: favoriteFields,
  });

  const combinedFields = combineMyFieldsWithSearchableCategories(
    standardFields,
    myFieldsItem,
  );

  return [
    {
      name: 'Fields',
      key: 'Fields',
      items: [myFieldsItem, ...combinedFields],
    },
  ];
};

export default buildSideNavCategories;
